import { useManagementKeys } from '@api/managementKeys';
import { DataGrid } from '@components/DataGrid';
import { Box } from '@mui/system';
import { DataGridProProps, GridRowParams } from '@mui/x-data-grid-pro';
import { getAccessKeysColumns } from '@utils/tables';
import { ACCESS_KEYS_FIELDS } from 'constants/global';
import React from 'react';
import { AccessKeyStatus, IAccessKey } from 'types/accessKeys';
import { IDataGridProps } from 'types/common';
import DeleteDialog from './Dialogs/DeleteDialog';
import EditDialog from './Dialogs/EditDialog';
import StatusDialog from './Dialogs/StatusDialog';

interface IManagementKeysTableProps
	extends Partial<IDataGridProps & DataGridProProps> {}

const ManagementKeysTable: React.FC<IManagementKeysTableProps> = ({
	...dataGridProps
}) => {
	const { data, isLoading } = useManagementKeys();
	const columns = getAccessKeysColumns();

	const getRowActions = (params: GridRowParams) => {
		const item = params.row as IAccessKey;
		const isActive = item.status === AccessKeyStatus.active;
		return [
			{
				key: 'edit',
				label: intl.tr('button.edit'),
				Dialog: EditDialog
			},
			{
				key: isActive ? 'deactivate' : 'activate',
				label: isActive
					? intl.tr('button.deactivate')
					: intl.tr('button.activate'),
				Dialog: StatusDialog
			},
			{
				key: 'delete',
				label: intl.tr('button.delete'),
				Dialog: DeleteDialog
			}
		];
	};

	return (
		<Box display="flex" flexGrow={1} data-testid="managementKeys-table">
			<DataGrid
				noDataMessageId="grid.data.no.data.managementKeys"
				rows={data?.data || []}
				loading={isLoading}
				getRowActions={getRowActions}
				columns={columns}
				checkboxSelection={false}
				initialState={{
					sorting: {
						sortModel: [{ field: ACCESS_KEYS_FIELDS.createdTime, sort: 'desc' }]
					}
				}}
				{...dataGridProps}
			/>
		</Box>
	);
};

export default ManagementKeysTable;
